import { OauthState } from "../../../data/oauth/oauth.state";
import { UserEnabledProperties } from "../../api/UserEnabledPropertiesService";

export const hasAnalyticsDashboardAccess = (oauthData: OauthState) =>
  UserEnabledProperties.AnalyticsStatus.schoolFlags(oauthData) ||
  UserEnabledProperties.WellBeing.dashboard(oauthData) ||
  UserEnabledProperties.AnalyticsStatus.moodStats(oauthData) ||
  UserEnabledProperties.AnalyticsStatus.usageStats(oauthData);
